/* eslint-disable react/require-default-props */
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { Alert, Button, Col, Form, Spinner } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { getSectionCodeError } from '../../../../actions/helpers/section.helper';

const SectionEditForm = ({
  handleEditMode,
  currentSection,
  currentCode,
  takenCodes = [],
  isNew,
  busy,
  busyLabel,
  saveError,
  handleSave,
}) => {
  const [title, setTitle] = useState(currentSection || '');
  const [code, setCode] = useState(currentCode || '');
  // Errors only show once the code has been edited.
  const [codeTouched, setCodeTouched] = useState(false);
  const codeChanged =
    !isNew && !!currentCode && code.trim().toLowerCase() !== currentCode.toLowerCase();
  // A code the section already carries is never re-validated: legacy codes
  // can be longer or shaped differently than what the form allows today.
  const codeError = isNew || codeChanged ? getSectionCodeError(code, takenCodes) : '';
  const canSave = !busy && title.trim() !== '' && !codeError;
  const onSave = () => {
    handleSave({
      title: title.trim(),
      code: code.trim(),
    });
  };
  return (
    <Col md="3" className="p-3 survey-sidebar edit-mode position-relative">
      {busy && (
        <div className="editor-loading-overlay">
          <Spinner animation="border" role="status" />
          {busyLabel}
        </div>
      )}
      <span
        className="d-flex"
        onClick={handleEditMode}
        onKeyDown={handleEditMode}
        role="button"
        tabIndex={0}
      >
        <FontAwesomeIcon size="sm" className="mr-3" icon={faChevronLeft} />
        Back to overview
      </span>
      <Col className="info-edit-form">
        <div>
          <h4 className="mb-2">Section Name</h4>
          <Form.Control
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Section Name"
            type="text"
            maxLength={75}
            value={title}
          />
          <span className="hint">Character Limit: 75</span>
        </div>
        <div>
          <h4 className="mb-2">Section Code</h4>
          <Form.Control
            onChange={(e) => {
              setCode(e.target.value.toUpperCase());
              setCodeTouched(true);
            }}
            placeholder="Section Code"
            type="text"
            maxLength={3}
            value={code}
            isInvalid={codeTouched && !!codeError}
          />
          <Form.Control.Feedback type="invalid">{codeError}</Form.Control.Feedback>
          <span className="hint">
            {isNew ? 'Generated automatically, you can change it. ' : ''}
            Letters and numbers, character limit: 3
          </span>
          {codeChanged && !codeError && (
            <span className="hint d-block">
              Every question in this section will be moved to {code.trim()}.
            </span>
          )}
        </div>
      </Col>
      {saveError && (
        <Alert variant="danger" className="mx-3">
          {saveError}
        </Alert>
      )}
      <Button
        variant="primary"
        onClick={onSave}
        disabled={!canSave}
        className="btn btn-custom dark"
      >
        Save
      </Button>
    </Col>
  );
};

SectionEditForm.propTypes = {
  currentSection: PropTypes.string.isRequired,
  currentCode: PropTypes.string,
  takenCodes: PropTypes.arrayOf(PropTypes.string),
  isNew: PropTypes.bool,
  busy: PropTypes.bool,
  busyLabel: PropTypes.string,
  saveError: PropTypes.string,
  handleEditMode: PropTypes.func.isRequired,
  handleSave: PropTypes.func.isRequired,
};

export default SectionEditForm;
